import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { decodeTrail, type NavState } from "./trail";

export function useNavState(): NavState {
  const [params] = useSearchParams();
  const rawTrail = params.get("trail") ?? "";
  const rawQuery = params.get("q") ?? "";

  return useMemo<NavState>(
    () => ({ trail: decodeTrail(rawTrail), query: rawQuery }),
    [rawTrail, rawQuery],
  );
}
